import React from 'react'

import { Skeleton } from '@mui/material'
import { getImageCsCart } from '@/lib/getImageCsCart'
import Image from 'next/image'

export const sizeImageProduct = 128
export const sizeMinImageProduct = 48

type Props = {
  product: any
  size?: string
  id?: string
}

export const useStyleProductImage = ({ size = 'large' }: { size?: string }) => ({
  image: `flex justify-center ${size === 'large' ? 'mb-4' : 'mb-1'} grow-[2]`,
  imageStyle: {
    height: size === 'large' ? sizeImageProduct : sizeMinImageProduct,
  },
})

const ProductImg: React.FC<Props> = ({ product, size = 'large', id }) => {
  const classes = useStyleProductImage({ size })

  if (!product)
    return (
      <Skeleton
        variant="rectangular"
        width={'100%'}
        height={size === 'large' ? sizeImageProduct : sizeMinImageProduct}
        animation={false}
      />
    )
  return (
    <div id={id} className={classes.image}>
      <Image
        src={getImageCsCart(product.image_pairs?.[0] || product.main_pair)}
        width={100}
        height={size === 'large' ? sizeImageProduct : sizeMinImageProduct}
        style={{
          minWidth: size === 'large' ? sizeImageProduct : sizeMinImageProduct,
          objectFit: 'contain',
          objectPosition: 'center',
        }}
        alt={product.product}
      />
    </div>
  )
}

export default ProductImg
